import { Link } from "react-router-dom";
import Container from "../ui/Container";
import { Mail, Phone, MapPin, ArrowUp, Globe } from "lucide-react";
import logo from "@/assets/logo.svg";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/data/translations";

const Footer = () => {
  const { language, setLanguage } = useLanguage();
  const t = translations[language];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-secondary pt-16 pb-8">
      <Container>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img src={logo} alt="StackAdvance" className="h-8 w-auto" />
            </Link>
            <p className="text-muted-foreground mb-6">
              {t.footer.description}
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/stack-advance"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-5 w-5"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect x="2" y="9" width="4" height="12"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
              {/* <a
                href="#"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Twitter"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-5 w-5"
                >
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="GitHub"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-5 w-5"
                >
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                </svg>
              </a> */}
            </div>
          </div>
          <div>
            <h3 className="text-base font-semibold mb-4">{t.footer.navigation}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.footer.home}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.footer.about}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.footer.products}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.footer.services}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-base font-semibold mb-4">{t.footer.resources}</h3>
            <ul className="space-y-2">
              {/* <li>
                <Link to="/clients" className="text-muted-foreground hover:text-primary transition-colors">
                  Клиенты
                </Link>
              </li> */}
              <li>
                <Link to="/news" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.footer.news}
                </Link>
              </li>
              {/* <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Политика конфиденциальности
                </a>
              </li> */}
              {/* <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Условия использования
                </a>
              </li> */}
            </ul>
          </div>
          <div>
            <h3 className="text-base font-semibold mb-4">{t.footer.contacts}</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="h-5 w-5 mr-2 text-primary" />
                <a href="tel:+375293326012" className="text-muted-foreground hover:text-primary transition-colors">
                  +375 (29) 332-60-12
                </a>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 mr-2 text-primary" />
                <a href="mailto:info@stackadvance.io" className="text-muted-foreground hover:text-primary transition-colors">
                  info@stackadvance.io
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 text-primary" />
                <span className="text-muted-foreground">
                  {t.footer.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground mb-4 md:mb-0">
            {t.footer.copyright.replace('{year}', new Date().getFullYear().toString())}
          </p>
          <div className="flex items-center space-x-6">
            <div className="flex items-center text-sm text-muted-foreground bg-muted/50 rounded-full px-3 py-1.5">
              <Globe className="h-4 w-4 mr-2" />
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value as 'ru' | 'en')}
                className="bg-transparent border-none rounued-fullded-full focus:ring-0 text-sm cursor-pointer hover:text-primary transition-colors"
              >
                <option value="ru">{t.language.ru}</option>
                <option value="en">{t.language.en}</option>
              </select>
            </div>
            <button
              onClick={scrollToTop}
              className="flex items-center text-sm text-muted-foreground bg-muted/50 rounded-full px-3 py-1.5 hover:text-primary transition-colors"
            >
              <span className="mr-2">{t.footer.backToTop}</span>
              <ArrowUp className="h-4 w-4" />
            </button>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
